require('slick-carousel');

let container = $('.featured-list');
let navigation = $('.nav-featured-list');
let mainCarousel = $('.main-featured-list');
let lock = false;

function updateBackground () {
  let background = navigation.find('.current').data('background');

  container.css('background-image', 'url(' + background + ')')
}

export default {
  fire() {
    mainCarousel.on('init', updateBackground);
    mainCarousel.slick({
      fade: true,
      arrows: false,
      swipe: false,
      adaptiveHeight: true,
    });
    navigation.on('click', '.featured', this.updateMainCarousel);

    container.addClass('loaded');
  },

  updateMainCarousel() {
    if (lock || 1 === 1) return;

    lock = true;

    let index = this.getAttribute('data-index');
    let self = this;

    mainCarousel.slick('slickGoTo', index);

    let skip = false;
    navigation.find('.featured').each(function () {
      if (this === self) skip = true;

      if (skip) return;

      let copy = this.cloneNode(true);

      this.remove();

      navigation.append(copy);
    });

    updateBackground();

    setTimeout(function () {
      lock = false;
    }, 500);
  },
};



// WEBPACK FOOTER //
// ./scripts/components/featured-carousel.js